import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Header from "./components/Header"; //头部
import Footer from "./components/Footer"; //头部
import Dialog from "./components/Dialog"; //弹窗
import "./styles/common.less"; //全局样式
import "./const/job"; //职位
import VideoPlayer from 'vue-video-player'


Vue.component("Header", Header);
Vue.component("Footer", Footer);
Vue.component("Dialog", Dialog);

Vue.config.productionTip = false;

Vue.use(VideoPlayer);


let flag = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);

if (flag) {
  window.location.href = "https://mobile.leimon.com.cn/";
} else {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
}




